const Colors = {
    colors: {
        color1: '#285a4a',
        color2: '#377a37',
        color3: '#527e4c',
        color4: '#6d8261',
        color5: '#9ab383',
        color6: '#e1e0c7',
    },
}

export default Colors;
